import { selfToursLink } from '../utils/profileLinks';

export default () => {
  window.location.replace(selfToursLink());
};
